const comments = [
  {
    avatar: 'R',
    name: '理性吃瓜人',
    time: '2小时前',
    content: '这个平台真的绝了，信息更新速度比微博热搜还快。昨天那个顶流的瓜，我是在这里先看到的，转发到群里大家都以为是假的，结果今天实锤了。',
    likes: '3.2k',
    tag: '老用户',
  },
  {
    avatar: 'M',
    name: '默默围观群众',
    time: '4小时前',
    content: '说实话暗网吃瓜的爆料准确率真的高，很多在其他平台被压下去的热搜，在这里都有完整的来龙去脉和时间线梳理，吃瓜吃得明明白白。',
    likes: '2.8k',
    tag: '活跃用户',
  },
  {
    avatar: 'Z',
    name: '真相追踪者',
    time: '6小时前',
    content: '财务造假那个瓜我关注一周了，今天终于看到完整的内部文件泄露版本。暗网吃瓜的深度挖掘能力确实强，建议出个会员功能，我愿意付费。',
    likes: '1.9k',
    tag: '资深吃瓜',
  },
  {
    avatar: 'N',
    name: '匿名用户A',
    time: '9小时前',
    content: '唯一不足是分类可以再细化一些，有时候想找特定行业的爆料要翻很久。不过整体体验已经很好了，比在各大平台切换找瓜效率高太多。',
    likes: '1.5k',
    tag: '普通用户',
  },
  {
    avatar: 'K',
    name: '看破不说破',
    time: '12小时前',
    content: '最欣赏这个平台的一点就是保护爆料人隐私，而且每条爆料都会标注信源可信度评级。吃瓜也要有态度，不能被假消息带节奏。希望继续保持！',
    likes: '1.2k',
    tag: '推荐官',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            吃瓜热评
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            来自吃瓜群众最真实的反馈，看看大家都在讨论什么
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {comments.slice(0, 2).map((comment, i) => (
            <div
              key={i}
              className="bg-background-100 border border-background-300/30 rounded-xl p-5 hover:border-primary-500/20 transition-all"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-primary-500/20 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-medium text-primary-400">{comment.avatar}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-medium text-foreground-800 truncate">{comment.name}</span>
                    <span className="text-[10px] px-1.5 py-0.5 rounded bg-accent-500/10 text-accent-400 whitespace-nowrap">
                      {comment.tag}
                    </span>
                  </div>
                  <span className="text-xs text-foreground-500">{comment.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">{comment.content}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
          {comments.slice(2).map((comment, i) => (
            <div
              key={i + 2}
              className="bg-background-100 border border-background-300/30 rounded-xl p-5 hover:border-primary-500/20 transition-all"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-accent-500/20 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-medium text-accent-400">{comment.avatar}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-medium text-foreground-800 truncate">{comment.name}</span>
                    <span className="text-[10px] px-1.5 py-0.5 rounded bg-secondary-500/10 text-secondary-400 whitespace-nowrap">
                      {comment.tag}
                    </span>
                  </div>
                  <span className="text-xs text-foreground-500">{comment.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">{comment.content}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}